<template>
  <div v-if="showPage403" class="animated fadeIn content-holder"> 
    <Page403></Page403>
  </div>
  <div v-else class="animated fadeIn content-holder">
    <b-card>
      <b-card-header class="custom-header">
        <div><i class="icon-settings mr-1"></i>Change History</div>
        <b-button @click="routerBack" variant="outline-primary">
          <i class="fa fa-angle-left"></i> Back
        </b-button>
      </b-card-header>
      <b-card-body v-if="isLoading">
        <spinner></spinner> 
      </b-card-body>
      <b-card-body v-else>
        <v-client-table id="historyTable" :data="data" :columns="columns" :options="options" :theme="theme">
        </v-client-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import Vue from 'vue';
  import miniToastr from 'mini-toastr';
  import VueNotifications from 'vue-notifications'
  import { ClientTable, Event } from 'vue-tables-2';
  import { apigClient } from '@/shared/api';
  import { router } from '../../router/index';
  import Page403 from "@/views/pages/Page403.vue";

  const Spinner = () => import('../shared/Spinner');

  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }

  miniToastr.init({types: toastTypes})

  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }

  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }

  Vue.use(VueNotifications, options)
  Vue.use(ClientTable);

  let columns = ['postedBy', 'postedAt', 'ip'];

  let headings = {
    postedBy: 'Updated By',
    postedAt: 'Updated At',
    ip: 'IP Address'
  }
  let sortable = ['postedBy', 'postedAt'];

  //Export component
  export default {
    name: 'FormBuilders',
    components: {
      ClientTable,
      Spinner,
      Page403
    },
    data: function () {
      let loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
      return {
        loginUserInfo: loginUserInfo,
        permission: {
          permissionBaseName: null,
          permissionBaseNameCapabilities: null,
          capabilities: {
            View: false,
            Edit: false,
            Delete: false,
            Create: false,
          }
        },
        showPage403: false,
        isLoading: true,
        columns: columns,
        data: [],
        options: {
          filterByColumn: true,
          headings: headings,
          sortable: sortable,
          sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
          pagination: {
            chunk: 5,
            edge: false,
            nav: 'scroll'
          }
        },
        useVuex: false,
        theme: 'bootstrap4',
        template: 'default',
        
        deleteModalOpen: false,
        id: null,
        title: null,
        wallet_id: null,

        //Use for info modal
        infoModalTitle: null,
        infoModalOpen: false,
        infoModalBody: null,
        infoModalOkVariant: 'success',
      }
    },
    methods: {
      getPermission(){
        let that = this;
        const userPermissionsBasedOnEntity = that.loginUserInfo.db.userPermissionsBasedOnEntity;
        if(this.$route.meta && userPermissionsBasedOnEntity){
          let userPermissionBasedOnEntity = userPermissionsBasedOnEntity.find(p => p.permissionBaseName === that.permission.permissionBaseName);
          if(userPermissionBasedOnEntity){
            that.permission.permissionBaseNameCapabilities = userPermissionBasedOnEntity.capabilities;
            that.permission.permissionBaseNameCapabilities.forEach(capability=>{
              that.permission.capabilities[capability.label] = capability.value
            });
          }
        } else{
          router.push('/no-permission-given');
        }
        console.log('permission: ' , that.permission);
      },
      convertDateTime: function(tmp, isTime) {
        let time = '';
        let a = new Date(tmp * 1000);
        let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        let year = a.getFullYear();
        let month = months[a.getMonth()];
        let date = a.getDate();
        let hour = a.getHours();
        let min = a.getMinutes();
        let sec = a.getSeconds();
        if (isTime) {
          time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec;
        } else {
          time = date + ' ' + month + ' ' + year;
        }
        return time;
      },
      routerBack(){
        this.$router.go(-1);
      },
      getData(){
        let that = this;
        apigClient.invokeApi({}, '/formBuilder/' + that.$route.params.id, 'GET', {})
          .then(function(result) {
            let response = result.data;
            if (response.status) {
              let formType = response.data.formType;
              that.permission.permissionBaseName = "component"+formType+"Builder";
              that.getPermission();
              if(!that.permission.capabilities.View){
                that.showPage403 = true;
                return;
              }
              that.loadCustomForms();

            } 
          })
      },
      loadCustomForms: function() {
        var method = 'GET';
        var pathTemplate = '/formBuilder/history/' + this.$route.params.id;
        var additionalParams ={};
        var pathParams = {};
        var that = this;
        apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams)
          .then(function(result) {
            let response = result.data.data.hits.hits;
            if (result.data.status) {
              let data = response.map((elem, index) => {
                elem.postedAt = that.convertDateTime(elem._source.created, true)
                elem.postedBy = elem._source.updatedBy
                elem.ip = elem._source.ip
                elem.id = index;
                return elem;
              });
              that.data = [...data];
              that.isLoading = false;
            } else {
              that.showErrorMsg({message: response.message});
              that.isLoading = false;
            }
          }).catch( function(error){
            that.showErrorMsg({message: error.message});
            that.isLoading = false;
          });
      },
    },
    mounted: function() {
      this.getData();
    },
    notifications: {
      showSuccessMsg: {
        type: VueNotifications.types.success,
        title: 'Operation successfull!',
        message: 'The media has been deleted'
      },
      showInfoMsg: {
        type: VueNotifications.types.info,
        title: 'Hey you',
        message: 'Here is some info for you'
      },
      showWarnMsg: {
        type: VueNotifications.types.warn,
        title: 'Wow, man',
        message: 'That\'s the kind of warning'
      },
      showErrorMsg: {
        type: VueNotifications.types.error,
        title: 'Error',
        message: 'Something goes wrong'
      }
    },
  }
</script>

<style lang="scss">
  #historyTable {
    width: 70%;

    .VuePagination {
      text-align: center;
      justify-content: center;
    }

    .vue-title {
      text-align: center ;
      margin-bottom: 10px;
    }

    .VueTables__search-field {
      display: flex;
    }
    .VueTables__search-field input {
      margin-left: 0.25rem;
    }

    .VueTables__limit-field {
      display: flex;
    }

    .VueTables__limit-field select {
      margin-left: 0.25rem !important;
    }

    .VueTables__table th {
      text-align: center;
    }

    .VueTables__child-row-toggler {
      width: 16px;
      height: 16px;
      line-height: 16px;
      display: block;
      margin: auto;
      text-align: center;
    }
    
    .action{
      display: flex;
      justify-content: center;
      align-items: center;
    } 
  }
  .custom-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .btn-secondary {
    background-color: none;  
  }
  .modal-dialog {
   color: black;
  }
  .container-fluid {
    margin:0!important;
    padding:0!important;
  }
  .breadcrumb {
    margin-bottom:0;
    border-bottom:0;
  }
</style>